import { useState } from 'react';

interface HeaderProps {
  scrolled: boolean;
}

export default function Header({ scrolled }: HeaderProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'bg-[#1a1a1a]/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}
    >
      <nav className="px-6 lg:px-12 py-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-[#c9a96e] to-[#d4c5b9] rounded-lg">
              <span className="text-[#1a1a1a] font-bold text-xl">K</span>
            </div>
            <span className="text-xl font-semibold text-[#d4c5b9]">Kenji Tanaka</span>
          </div>

          <div className="hidden lg:flex items-center space-x-10">
            <a href="#about" className="text-sm hover:text-[#c9a96e] transition-colors duration-300 cursor-pointer">
              About
            </a>
            <a href="#services" className="text-sm hover:text-[#c9a96e] transition-colors duration-300 cursor-pointer">
              Services
            </a>
            <a href="#portfolio" className="text-sm hover:text-[#c9a96e] transition-colors duration-300 cursor-pointer">
              Portfolio
            </a>
            <a href="#blog" className="text-sm hover:text-[#c9a96e] transition-colors duration-300 cursor-pointer">
              Blog
            </a>
            <a href="#contact" className="text-sm hover:text-[#c9a96e] transition-colors duration-300 cursor-pointer">
              Contact
            </a>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex flex-col items-center justify-center space-y-1.5 cursor-pointer"
          >
            <span className={`w-6 h-0.5 bg-[#c9a96e] transition-all duration-300 ${mobileMenuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
            <span className={`w-6 h-0.5 bg-[#c9a96e] transition-all duration-300 ${mobileMenuOpen ? 'opacity-0' : ''}`}></span>
            <span className={`w-6 h-0.5 bg-[#c9a96e] transition-all duration-300 ${mobileMenuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
          </button>
        </div>

        {mobileMenuOpen && (
          <div className="lg:hidden mt-6 pb-6 space-y-4">
            <a href="#about" className="block text-sm hover:text-[#c9a96e] transition-colors duration-300 cursor-pointer">
              About
            </a>
            <a href="#services" className="block text-sm hover:text-[#c9a96e] transition-colors duration-300 cursor-pointer">
              Services
            </a>
            <a href="#portfolio" className="block text-sm hover:text-[#c9a96e] transition-colors duration-300 cursor-pointer">
              Portfolio
            </a>
            <a href="#blog" className="block text-sm hover:text-[#c9a96e] transition-colors duration-300 cursor-pointer">
              Blog
            </a>
            <a href="#contact" className="block text-sm hover:text-[#c9a96e] transition-colors duration-300 cursor-pointer">
              Contact
            </a>
          </div>
        )}
      </nav>
    </header>
  );
}